var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link btn-wide",attrs:{"type":"button","tabindex":"1"},on:{"click":_vm.postMessageToWindow}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }